// The share/copy glyph — previously copy-pasted as inline SVG in 5 places
// (App's share + end-game share/feedback buttons, Compose, Move). `mirrored`
// renders the horizontally-flipped variant used by the end-game feedback button.
function ShareIcon({ mirrored = false }) {
  return (
    <svg
      height="20"
      width="20"
      fill="none"
      transform={mirrored ? "scale(-1, 1)" : undefined}
      style={mirrored ? { WebkitTransform: "scale(-1, 1)" } : undefined}
    >
      <path stroke="currentColor" d="M14.734 15.8974L19.22 12.1374C19.3971 11.9927 19.4998 11.7761 19.4998 11.5474C19.4998 11.3187 19.3971 11.1022 19.22 10.9574L14.734 7.19743C14.4947 6.9929 14.1598 6.94275 13.8711 7.06826C13.5824 7.19377 13.3906 7.47295 13.377 7.78743V9.27043C7.079 8.17943 5.5 13.8154 5.5 16.9974C6.961 14.5734 10.747 10.1794 13.377 13.8154V15.3024C13.3888 15.6178 13.5799 15.8987 13.8689 16.0254C14.158 16.1521 14.494 16.1024 14.734 15.8974Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>
  );
}

export default ShareIcon;
